import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import client from "@/lib/api";

export default function AdminActivityPage() {
  const [activity, setActivity] = useState([]);
  useEffect(() => {
    client.get("/admin/activity").then((r) => setActivity(r.data)).catch(() => {});
  }, []);

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><History size={17} style={{ color: "var(--k-gold-deep)" }} /> سجل النشاط</h2>
      <div className="px-4 pb-6">
        {activity.length === 0 ? <p className="text-[13px]" style={{ color: "var(--k-ink-soft)" }}>لا يوجد نشاط بعد</p> : (
          <div className="rounded-2xl overflow-hidden" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
            {activity.slice(0, 80).map((a) => (
              <div key={a.id} data-testid={`activity-${a.id}`} className="px-3.5 py-2.5 text-[12px]" style={{ borderBottom: "1px solid var(--k-line)" }}>
                <div className="flex justify-between items-center gap-2">
                  <span className="flex items-center gap-1.5 flex-wrap">
                    {a.section && <span className="text-[9.5px] font-bold px-1.5 py-0.5 rounded-md" style={{ background: "var(--k-gold-tint)", color: "var(--k-gold-deep)" }}>{a.section}</span>}
                    <span className="font-bold">{a.action}</span>
                    {a.target && <span style={{ color: "var(--k-ink-soft)" }}>· {a.target}</span>}
                  </span>
                  <span className="text-[10px] font-num shrink-0" style={{ color: "var(--k-ink-soft)" }}>{(a.who || "").split("@")[0]} · {(a.at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                {(a.old !== undefined || a.new !== undefined) && (
                  <div className="mt-1 flex items-center gap-1.5 text-[11px] font-num">
                    {a.old !== undefined && <span className="px-1.5 py-0.5 rounded" style={{ background: "rgba(220,53,69,.08)", color: "var(--k-ruby)" }}>{String(a.old)}</span>}
                    <span style={{ color: "var(--k-ink-soft)" }}>←</span>
                    {a.new !== undefined && <span className="px-1.5 py-0.5 rounded" style={{ background: "rgba(16,124,86,.1)", color: "var(--k-emerald)" }}>{String(a.new)}</span>}
                    {a.ip && <span className="text-[9.5px] ms-auto" style={{ color: "var(--k-ink-soft)" }}>IP {a.ip}</span>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
